//VALIDATIONS
//import { required, minLength } from "@vuelidate/validators";

export default class Permission {
    constructor() {
        this.id = null;
        this.description = null;
    }

}